var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/slider-macros.j2"] = require( "macros/slider-macros.j2" );
dependencies["carousel-slider/slider-slides.j2"] = require( "carousel-slider/slider-slides.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/carousel-slider/slider-product-image-container.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/slider-macros.j2", false, "product/templates/carousel-slider/slider-product-image-container.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("create_slider_arrows")) {
var t_4 = t_1.create_slider_arrows;
} else {
cb(new Error("cannot import 'create_slider_arrows'")); return;
}
context.setVariable("create_slider_arrows", t_4);
output += "<div class=\"o-slider-thumbnails__wrapper o-slider-thumbnails__wrapper--pdp\" data-qa-slider-thumbnails>\n\n    <div class=\"o-slider-thumbnails o-slider-thumbnails--product-image js-slider--product-image u-centered-content\">\n\n        ";
env.getTemplate("carousel-slider/slider-slides.j2", false, "product/templates/carousel-slider/slider-product-image-container.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n    </div>\n\n    ";
output += runtime.suppressValue((lineno = 10, colno = 25, runtime.callWrap(t_4, "create_slider_arrows", context, [runtime.makeKeywordArgs({"isSmallArrow": runtime.contextOrFrameLookup(context, frame, "True"),"classPrefix": "slider-thumbnails"})])), env.opts.autoescape);
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/carousel-slider/slider-product-image-container.j2"] , dependencies)